import { useState } from 'react'

import { ConfirmDialog } from '../../../components/ConfirmDialog'
import { useAppToast } from '../../../helpers'
import { RequestService } from '../../../services/Request/RequestService'

export interface IRequestDeleteDialogProps {
  isOpen: boolean
  onClose: () => void
  request: { id: number } | undefined
  onDelete: () => void
}

/**
 * Mantido como componente porque a listagem e o modal de detalhe abrem o mesmo diálogo
 * com desfechos diferentes — inlinar duplicaria o handler nas duas telas.
 */
export function RequestDeleteDialog({ isOpen, onClose, request, onDelete }: IRequestDeleteDialogProps) {
  const requestService = new RequestService()
  const [isLoading, setIsLoading] = useState(false)
  const toast = useAppToast()

  const handleDelete = async () => {
    if (!request) {
      return
    }

    setIsLoading(true)
    try {
      await requestService.delete(request.id)
      toast.success('Solicitação excluída')
      onDelete()
      onClose()
    } catch (error) {
      toast.error('Erro ao excluir solicitação', error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <ConfirmDialog
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={handleDelete}
      action="delete"
      entity="solicitação"
      feminine
      isLoading={isLoading}
    />
  )
}
